import axios from "axios";
import router from "../router";

// 创建一个axios实例
const ajax = axios.create({
  // 根据不同的值来使用不同的api
  baseURL: process.env.NODE_ENV === 'production' ? 'https://api.vimiuvr.com/' : 'https://test.vimiuvr.com/'
});


// baseURL: 'https://test.vimiuvr.com/'   //日常使用

  // baseURL:'https://api.vimiuvr.com/'   //线上使用

/**
 * 拦截器 -- 请求拦截--request，响应拦截--response
 */
ajax.interceptors.request.use(config => {
  /** 如果需要判断用户权限，那么要获取token */
  let vm_token = localStorage.getItem("vm_token");
  // let vm_token = 'hc6Q6pWi1q9eDfxP2%2BOlhm9qksjpaAM5vi3vW2BSqyx%2F0w4TQkVeXNhNCnglgJorSY%2BkCwsrynrZ4cRT4jdcrU5YkClktvVB3w1RJq6rybVtEf1LUjMm2%2BixtvgNnt0O'
  // if (!token) return Promise.reject({code: 900, message: '用户没有访问此接口的权限'})

  /** 有token，就应该把token添加到请求头上 */
  config.headers.vm_token = vm_token;
  return config;
});
ajax.interceptors.response.use(function(responseObject) {
  let { data } = responseObject;
  if (data.code === 1003) {
    // 提示用户登录已经时效--token没有
    alert("用户的token已经失效，请重新登录");
    router.push("/");
    return Promise.reject({ code: 999, message: "用户需要重新登录" });
  } else {
    return responseObject;
  }
});

/**
 * 封装的ajax请求
 * @param {{url: string, data: any, params: {} | undefined, method: "POST" | "GET" | "PUT" | "DELETE"}} req 请求对象
 * @returns Promise
 */
export default function ajaxFunc(req) {
  return new Promise(resolve => {
    ajax
      .request({
        url: req.url,
        method: req.method || "post",
        headers: req.headers || {},
        data: req.data || {},
        params: req.params || {}
      })
      .then(({ data }) => {
        resolve(data);
      })
      .catch(e => {
        resolve(e);
      });
  });
}



// WEBPACK FOOTER //
// ./src/api/ajax.js